import { getLocaleLanguage } from '~/utils/locale/locale';

const decimalFormatter: Intl.NumberFormat = new Intl.NumberFormat(
  getLocaleLanguage(),
  { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 }
);

export function formatDecimal(value: number): string {
  return decimalFormatter.format(value);
}

const integerFormatter: Intl.NumberFormat = new Intl.NumberFormat(
  getLocaleLanguage(),
  { style: 'decimal', maximumFractionDigits: 0 }
);

export function formatInteger(value: number): string {
  return integerFormatter.format(value);
}

export function numberWithCommas(x: number | string): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function logicalXOR(a: boolean, b: boolean): boolean {
  return (a && !b) || (!a && b);
}

export function numberRoundedToPrecision(num: number, precision = 2) {
  return Number(num.toFixed(precision));
}

export const decimalCount = (n: number | string): number => {
  try {
    if (Number.isInteger(parseFloat(n as string)) || n === '') {
      return 0;
    }
    return n.toString().split('.')[1].length;
  } catch {
    return 0;
  }
};

export const cryptoRandom = () => {
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  return crypto.getRandomValues(array)[0];
};
